import api from '../api'

export const auth = async (email: string, password: string) => {
  if (process.env.REACT_APP_CLIENT_ID || process.env.REACT_APP_CLIENT_SECRET) {

    let formData = new FormData();
    formData.append("client_id", process.env.REACT_APP_CLIENT_ID as string);
    formData.append("client_secret", process.env.REACT_APP_CLIENT_SECRET as string);
    formData.append("grant_type", "password");
    formData.append("password", password);
    formData.append("username", email);

    const { data } = await api.post('o/token/', formData);

    return data
  } else {
    throw new Error("REACT_APP_CLIENT_ID or REACT_APP_CLIENT_SECRET is not set in .env file")
  }  
}

export const me = async () => {
  const { data } = await api.get('profile/me/');

  return data
}

export const subscription = async () => {
  const { data } = await api.get('profile/subscription/');

  return data
}

export const recoveryPassword = async (email: string) => {
  const { data } = await api.post('password_recovery/', { email: email});

  return data
}